import DefaultLayout from "layouts/DefaultLayout";
import Processing from 'pages/Processing/Processing';
import React from "react";
import { useSelector } from "react-redux";
import { Route, withRouter } from 'react-router-dom';
import userManager from "userManager";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const oidc = useSelector(state => state.oidc);
  const { user, isLoadingUser } = oidc;
  const userExists = user && !isLoadingUser;

  return <Route {...rest} render={(props) => {
    if (userExists) {
      return <Component {...props} />;
    } else {
      userManager.clearStaleState().then(() => {
        userManager.signinRedirect();
      })
      return <DefaultLayout>
        <Processing message={"Redirecting..."} />
      </DefaultLayout>
    }
  }} />
}

export default withRouter(props => <PrivateRoute {...props} />);
